import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { Button } from '../ui/button';

const labels = { hiker: 'HikerAPI', rocket: 'RocketAPI' };
const errorText = e => e?.response?.data?.error || e?.message || 'Could not update the scraping provider.';

export default function ScraperSettingsCard() {
  const { data, error, isLoading, refetch } = useQuery({ queryKey: ['scraping-provider'], queryFn: () => api.get('/admin/scraping-provider').then(r => r.data), retry: false });
  const [provider, setProvider] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('');
  useEffect(() => { if (data?.provider) setProvider(data.provider); }, [data]);
  async function save() {
    setBusy(true); setStatus('');
    try {
      const result = await api.post('/admin/scraping-provider', { provider });
      setStatus(`${labels[result.data.provider]} saved. New scraping requests use this provider.`);
      await refetch();
    } catch (e) { setStatus(errorText(e)); }
    finally { setBusy(false); }
  }
  if (error?.response?.status === 403) return null;
  return <section className="aurora-card p-5 mb-6" aria-labelledby="scraper-provider-title">
    <h2 id="scraper-provider-title" className="text-lg font-semibold">Instagram scraping provider</h2>
    <p className="text-sm text-muted-foreground mt-1">Choose the service used for account posts, direct post links and profile lookups. Provider failures are reported without automatically charging the other service.</p>
    {error ? <p role="alert" className="mt-3">{errorText(error)} <Button variant="outline" onClick={() => refetch()}>Retry</Button></p> : isLoading || !provider ? <p className="mt-3">Loading scraping settings…</p> : <>
      <p className="text-sm mt-3">Currently saved: <strong>{labels[data.provider]}</strong></p>
      <fieldset disabled={busy} className="flex gap-5 mt-4">
        <legend className="sr-only">Scraping provider</legend>
        {Object.entries(labels).map(([value, label]) => <label key={value} className="flex items-center gap-2 text-sm"><input type="radio" name="scraping-provider" value={value} checked={provider === value} onChange={() => { setProvider(value); setStatus(''); }} />{label}</label>)}
      </fieldset>
      <p className="text-sm text-muted-foreground mt-3">The selection survives server restarts. API credentials remain on the server. Saving does not verify the provider’s key or balance.</p>
      <Button className="mt-4" disabled={busy || provider === data.provider} onClick={save}>{busy ? 'Saving…' : 'Save provider'}</Button>
      {status && <p role="status" className="text-sm mt-3">{status}</p>}
    </>}
  </section>;
}
